<div class="overlay-container"></div>

<div class="loader-wrapper">
  <div class="c-loader position-static"></div>
  <p class="loader-label" *ngIf="loaderMessage">
    {{ loaderMessage }}
  </p>
</div>
